import { getPath } from '@/router/common'

const baseUrl = {
  title: '上传用户头像',
  path: 'uploadUserAvatar'
}

export default[
    {
        path: getPath('Index', baseUrl),
        name: 'uploadUserAvatar_Index',
        component: () => import(/* webpackChunkName: "uploadUserAvatar_Index" */ '@/views/uploadUserAvatar/index/index.vue'),
        meta: {
          title: '上传用户头像'
        }
      }
]